export default function getProgressFromPast(initialValue, newValue) {
	//This function calculates the percentage progress of the previous value: initialValue (past): 200, newValue(today): 10 OUTPUT: -95
	if (initialValue === 0) return 0;
	if (newValue === 0) return -100;
	if (initialValue !== 0) return Math.floor(((newValue - initialValue) / initialValue) * 100);
	return Math.floor(newValue * 100);
}
